<template>
	<v-dialog
		v-model="dialog"
		max-width="1200px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				:text="text"
				:color="text ? 'white' : 'secondary'"
				class="ml-2"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-1">mdi-file-document-remove-outline</v-icon>
				削除履歴
			</v-btn>
		</template>

		<v-card tile>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">削除履歴</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-sheet elevation="0" class="pa-2">
				<div class="table-container">
					<v-data-table
						locale="ja-JP"
						:items="files"
						:headers="headers"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr class="no-click">
								<td>
									{{ item.feature.name }}
								</td>
								<td>{{ item.name }}</td>
								<td>{{ common.formatDate(item.destroy_date) }}</td>
								<td>
									<a :href="item.url" target="_blank">
										{{ item.destroy_user.full_name }}
									</a>
								</td>
								<td>
									<!-- TODO: -->
									<p>
										{{ item.reason }}
									</p>
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
				<v-row no-gutters class="mt-4" justify="end">
					<v-btn text @click="dialog = false">閉じる</v-btn>
				</v-row>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import rules from "../../../helper/rules"
import common from "../../../helper/common"

export default {
	props: {
		text: Boolean,
		files: {
			type: Array,
			required: false,
			default: () => {
				return []
			},
		},
	},
	data() {
		return {
			dialog: false,
			headers: [
				{ text: "添付機能", value: "feature.name", width: "150px" },
				{ text: "ファイル名", value: "name", width: "200px" },
				{ text: "削除日", value: "destroy_date", width: "120px" },
				{ text: "削除者", value: "destroy_user.full_name", width: "120px" },
				{ text: "削除理由", value: "reason", width: "200px" },
			],
			rules,
			common,
		}
	},
}
</script>